import React from 'react';

export const PaymentSkeleton = () => (
    <div className="rounded-xl bg-white p-3">
      <div className="h-4 w-32 animate-pulse rounded bg-gray-200" />

      <div className="mt-3  rounded-xl bg-gray-50 p-3">
        <div className="flex items-center justify-between">
          <div>
            <div className="h-3 w-20 animate-pulse rounded bg-gray-200" />
            <div className="mt-2 h-4 w-40 animate-pulse rounded bg-gray-200" />
          </div>
          <div className="flex items-center gap-3">
            <div className="h-6 w-20 animate-pulse rounded bg-gray-200" />
            <div className="h-6 w-20 animate-pulse rounded bg-gray-200" />
            <div className="h-6 w-20 animate-pulse rounded bg-gray-200" />
          </div>
        </div>
        <div className="h-11.5 mt-4 w-full animate-pulse rounded-xl bg-gray-200" />
      </div>
    </div>
  );
